import angular from 'angular';

var module = angular.module('app.gift-list', []);

export default module;